export default __webpack_public_path__ + "static/media/ui-icon-wscore.20c6e95f.png";